import styled, { css } from 'styled-components';

import Text, { TextProps } from '~components/Text';
import { getFontStyle } from '~components/Text/helper';

import { SelectProps } from '.';

interface StyledSelectedProps extends Pick<SelectProps, 'inlineSelectCss'> {
  hasError?: boolean;
  selected: boolean;
}

export const S = {
  SelectWrapper: styled.div<Pick<SelectProps, 'inlineWrapperCss'> & { fullWidth: boolean }>`
    position: relative;
    display: flex;
    flex-direction: column;

    ${({ theme }) => theme.media.mobile} {
      width: 100%;
    }

    width: ${({ fullWidth }) => (fullWidth ? '100%' : '320px')};
    ${({ inlineWrapperCss }) => inlineWrapperCss};
  `,

  Label: styled.label`
    text-align: left;
    margin-bottom: 4px;
    ${getFontStyle('midium150_B3')};
  `,
  StyledSelect: styled.select<StyledSelectedProps>`
    height: 48px;
    border: 1px solid ${({ theme }) => theme.colors.gray400};
    background-color: ${({ theme }) => theme.colors.white100};
    border-radius: 4px;
    padding: 12px 16px;
    color: ${({ theme }) => theme.colors.gray600};
    font-size: 16px;
    cursor: pointer;

    -moz-appearance: none; /* Firefox */
    -webkit-appearance: none; /* Safari and Chrome */
    outline: none;
    appearance: none;

    ${(props) =>
      props.selected &&
      css`
        color: ${({ theme }) => theme.colors.gray900};
      `}
    &:focus {
      border-color: ${({ theme }) => theme.colors.gray600};
      ${(props) =>
        props.hasError
          ? css`
              border-color: ${({ theme }) => theme.colors.red500};
            `
          : css`
              border-color: ${({ theme }) => theme.colors.gray600};
            `}
      outline: none;
    }

    &::placeholder {
      color: ${({ theme }) => theme.colors.gray600};
      ${getFontStyle('midium150_B1')};
      font-size: 16px;
    }

    &:disabled {
      background-color: ${({ theme }) => theme.colors.gray300};
      cursor: not-allowed;
    }
    ${(props) =>
      props.hasError &&
      css`
        border: 1px solid ${({ theme }) => theme.colors.red500};
      `};

    option {
      color: ${({ theme }) => theme.colors.gray900};

      &:disabled {
        color: ${({ theme }) => theme.colors.gray600};
      }
    }

    ${({ inlineSelectCss }) => inlineSelectCss};
  `,
  ArrowIcon: styled.div<{ hasLabel: boolean }>`
    cursor: pointer;

    svg {
      position: absolute;
      right: 25px;
      top: 48px;
    }

    ${(props) =>
      !props.hasLabel &&
      css`
        svg {
          top: 21px;
        }
      `}
  `,
  Error: styled(Text)<TextProps>`
    color: ${({ theme }) => theme.colors.red500};
    text-align: left;
    font-size: 12px;
    padding-top: 4px;
  `,
};
